var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        title: _vm.$t("SeaExport.Charge") + _vm.$t("SeaExport.Details"),
        visible: _vm.innerVisible,
        width: "1200px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "div",
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", "min-height": "400px" },
            attrs: {
              "config-module": "2023040701",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }